"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.business = void 0;
var business = {
  name: '@WORK',
  link: '/beneficios',
  logo: 'Business',
  colors: {
    active: 'fontNeutral90',
    font: 'fontNeutral60',
    background: 'backgroundNeutral10'
  },
  links: [{
    id: 'emprestimo-consignado',
    label: 'Empréstimo consignado',
    link: '/emprestimo/consignado-privado'
  }, {
    id: 'business-store',
    label: 'Creditas Store',
    link: '/store'
  }, {
    id: 'antecipacao-de-salario',
    label: 'Antecipação de salário',
    link: '/beneficios-corporativos/antecipacao-salario'
  }, {
    id: 'cartao-de-beneficios',
    label: 'Cartão de benefícios flexíveis',
    link: '/beneficios/cartao'
  }, {
    id: 'previdencia-privada',
    label: 'Previdência Privada',
    link: 'https://vantagens.creditas.com.br/previdencia-privada/'
  }]
};
exports.business = business;